import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import SnackProvider from "./context/Snackbar/SnackProvider";
import ThemeProvider from "./context/Theme/ThemeProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ThemeProvider>
    <SnackProvider>
      <App />
    </SnackProvider>
  </ThemeProvider>
);
